import type { AccountProperty } from '../../../../generated-types';
import { AccountCardItem } from '../../../../models/account';

export default (accountsInOrder: AccountCardItem[], checkedItems: Map<string, boolean>): AccountProperty[] =>
    accountsInOrder.map((account, index) => ({
        sortingKey: index + 1,
        frontpage: checkedItems.get(account.accountNumber.value) ?? false,
        accountNumber: account.accountNumber,
    }));
